// extracted by mini-css-extract-plugin
export default {"table":"ValidationTable_table__ZlH-O"};